import { Avatar, Divider, List, Skeleton } from "antd";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import CorrectIcon from "../../assets/images/dashboard/CorrectIcon.svg";
import IncorrectIcon from "../../assets/images/dashboard/IncorrectIcon.svg";

// css
import "../../assets/css/dashboard.scss";

const App = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const loadMoreData = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    fetch(
      "https://randomuser.me/api/?results=10&inc=name,gender,email,nat,picture&noinfo"
    )
      .then((res) => res.json())
      .then((body) => {
        setData([...data, ...body.results]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    loadMoreData();
  }, []);
  return (
    <>
      <div className="row  px-4 py-4 my-1 ">
        <div className="col-8 d-flex justify-content-start align-items-center">
          <p className="mb-0 pl-lg-5 appoinment-text">Latest Appoinment </p>
        </div>

        <div className="col-4 d-flex justify-content-end align-items-center">
          <p className="mb-0 appoinment-count-text">{data.length} Patients</p>
        </div>
      </div>

      <div
        className="border-top mx-2 pt-3 remove-x-overflow-doc-list"
        id="scrollableDiv"
        style={{
          height: 401,
          overflow: "auto",
          padding: "0 8px",
        }}
      >
        <InfiniteScroll
          dataLength={data.length}
          next={loadMoreData}
          hasMore={data.length < 50}
          loader={
            <Skeleton
              avatar
              paragraph={{
                rows: 1,
              }}
              active
            />
          }
          endMessage={<Divider plain>It is all, nothing more 🤐</Divider>}
          scrollableTarget="scrollableDiv"
        >
          <List
            dataSource={data}
            renderItem={(item) => (
              <>
                <div className="row  py-1">
                  <div className="col-8">
                    <div className="d-flex appoinment-detail align-items-center">
                      <img
                        className="appoinment-detail-img cursor-pointer"
                        src={item.picture.large}
                        alt=""
                      />

                      <div className="appoinment-detail-text pl-4 d-flex justify-content-center flex-column">
                        <p className="mb-0 appoinment-detail-text-1">
                          {item.name.last}
                        </p>
                        <p className="mb-0 appoinment-detail-text-2">
                          Booking on 27th Nov, 2020
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-4 d-flex justify-content-end pr-3">
                    <div className=" d-flex appoinment-correction pt-2">
                      <div className="  appoinment-correction-correct">
                      <i class="fa-solid fa-check appoinment-correction-correct-i"></i>
                      </div>

                      <div className="  appoinment-correction-incorrect ml-1 ">
                      <i class="fa fa-close appoinment-correction-incorrect-i"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          />
        </InfiniteScroll>
      </div>
    </>
  );
};
export default App;
